import { render } from "./register.vue?vue&type=template&id=61911658&scoped=true&ts=true"
import script from "./register.vue?vue&type=script&lang=ts"
export * from "./register.vue?vue&type=script&lang=ts"

import "./register.vue?vue&type=style&index=0&id=61911658&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61911658"]])

export default __exports__